import {Model} from './Model';
import {OptionDependency} from './OptionDependency';
import {DynamicElement} from './DynamicElement';

export class VisitorSurveyQuestion extends Model {
  public questionId: number = 0;
  public element!: DynamicElement;
  public dependantQuestions: Array<OptionDependency> = [];

  constructor(data: any) {
    super(data);

    this.questionId = data.questionId;
    this.dependantQuestions = data.dependantQuestions.map(dq => new OptionDependency(dq));
  }

  public toString(): string {
    return `VisitorSurveyQuestion<${this.id}>`;
  }
}
